import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import dynamic from "next/dynamic";
import { useForm } from "react-hook-form";
import { toast } from "sonner";

const NewsletterForm = dynamic(() => import("./NewsletterForm"), { ssr: false });

const NewsletterSignup = () => {
  return (
    <div className="w-full bg-neutral-950 text-neutral-50 rounded-xl p-4 shadow-lg mb-6">
      <h2 className="text-md font-semibold mb-1">Subscribe to MoneyOval</h2>
      <NewsletterForm />
    </div>
  );
};

export default NewsletterSignup;
